module.exports = __webpack_public_path__ + "img/wl_prod2_3.c4b8886a.jpg";